import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionDirective } from '@principle-theorem/ng-principle-shared';
import { ReportingPermissions } from '@principle-theorem/principle-core/features';
import { CustomReportStatus } from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { CustomReportsListComponent } from './custom-report/custom-reports-list/custom-reports-list.component';
import { CustomReportsService } from './custom-reports.service';

@Component({
  selector: 'pr-custom-reports',
  templateUrl: './custom-reports.component.html',
  styleUrls: ['./custom-reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    CustomReportsListComponent,
    HasPermissionDirective,
    MatButton,
  ],
})
export class CustomReportsComponent {
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);
  private _customReports = inject(CustomReportsService);

  private _reportStatus = toSignal(
    this._route.data.pipe(
      map((data) => data.reportStatus as CustomReportStatus)
    )
  );
  private _availableReports = toSignal(
    this._customReports.getAvailableReports$(),
    {
      initialValue: [],
    }
  );

  filteredReports = computed(() =>
    this._availableReports().filter(
      (report) => report.status === this._reportStatus()
    )
  );

  createCustomReportsPermission =
    ReportingPermissions.ReportingCustomReportEdit;

  async createCustomReport(): Promise<void> {
    const reportRef = await this._customReports.createCustomReport();
    if (!reportRef) {
      return;
    }
    await this._router.navigate(['/reporting/custom-reports', reportRef.id], {
      relativeTo: this._route,
    });
  }
}
